import { render, staticRenderFns } from "./C_Creator_EditQuests_Item_Explore_creatorTerms.vue?vue&type=template&id=88904ecc&scoped=true&"
import script from "./C_Creator_EditQuests_Item_Explore_creatorTerms.vue?vue&type=script&lang=js&"
export * from "./C_Creator_EditQuests_Item_Explore_creatorTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88904ecc",
  null
  
)

export default component.exports